import React from "react";
import Marquee from "react-fast-marquee";
import "../styles/Top.css";

const Top = () => {
  return (
    <div className="marquee-container-wrapper">
      <Marquee gradient={false} speed={90} pauseOnHover={true}>
        <span className="marquee-text">
          Herbal wellness supplement • Not a medicine • Free delivery Pan India  • Results may vary
        </span>
      </Marquee>
    </div>
  );
};

export default Top;